import openai from './openaiClient';

/**
 * System message for Golden Solution tool - fixed prompt
 */
const GOLDEN_SOLUTION_SYSTEM_MESSAGE = `Você é a ferramenta "Solução de Ouro", um consultor de alto nível que entrega soluções práticas, claras e com melhor custo-benefício.

Regras obrigatórias:

Use APENAS os dados do JSON fornecido.

Seja direto, organizado e extremamente útil.

Não invente informações do usuário.

Não repita o JSON.

Não diga que você "não pode" ajudar: sempre entregue um plano prático.

Sempre inclua um próximo passo concreto que a pessoa possa fazer HOJE.

Se o usuário marcou que quer indicações, inclua indicações por faixa de preço (barato / custo-benefício / premium).

Se não houver opção local, ofereça opções online.

Se o problema envolver saúde mental/física/emocional, inclua um aviso curto de segurança ("não substitui profissional de saúde") sem alarmismo.

Formato da resposta (sempre nesta ordem):

Diagnóstico rápido

Solução recomendada (passo a passo)

O que fazer hoje (em 15–30 minutos)

Plano de 7 dias

Riscos/erros comuns

Se quiser ajuda profissional (opcional)

NUNCA imponha limite de tamanho na resposta. Seja completo.`;

/**
 * Generates Golden Solution response using OpenAI gpt-4o
 * @param {Object} payload - The golden_solution_payload object
 * @returns {Promise<string>} The AI-generated solution
 */
export async function generateGoldenSolution(payload) {
  try {
    // Add context about checkbox confirmation
    const checkboxContext = payload?.quero_solucao_de_ouro 
      ? '\n\nO usuário marcou: Quero uma Solução de Ouro para esse Problema.' :'';

    const userMessage = `Vou te enviar um JSON com informações do usuário e o problema dele. Gere a melhor solução possível com qualidade máxima e melhor custo-benefício.${checkboxContext}

JSON: ${JSON.stringify(payload, null, 2)}`;

    const response = await openai?.chat?.completions?.create({
      model: 'gpt-4o',
      messages: [
        {
          role: 'system',
          content: GOLDEN_SOLUTION_SYSTEM_MESSAGE
        },
        {
          role: 'user',
          content: userMessage
        }
      ],
      temperature: 0.7,
    });

    return response?.choices?.[0]?.message?.content;
  } catch (error) {
    console.error('Error generating golden solution:', error);
    
    if (error?.message?.includes('API key')) {
      throw new Error('Chave da API OpenAI não configurada. Verifique suas variáveis de ambiente.');
    }
    
    throw new Error(`Erro ao gerar Solução de Ouro: ${error.message}`);
  }
}